import { createAction } from "@reduxjs/toolkit";
import {
  addCardActionTypes,
  deleteCardActionTypes,
  getCardsActionTypes,
} from "./actionTypes";

export const addCard = createAction(addCardActionTypes.request);
export const addCardSuccess = createAction(addCardActionTypes.success);
export const addCardFailure = createAction(addCardActionTypes.failure);

export const getCards = createAction(getCardsActionTypes.request);
export const getCardsSuccess = createAction(getCardsActionTypes.success);
export const getCardsFailure = createAction(getCardsActionTypes.failure);

export const deleteCard = createAction(deleteCardActionTypes.request);
export const deleteCardSuccess = createAction(deleteCardActionTypes.success);
export const deleteCardFailure = createAction(deleteCardActionTypes.failure);
